import React from "react";
import './nosotros.css';
import TitleDisplayerComponent from "../TitleDisplayer/titledisplayer";
import { useEffect, useRef, useState } from "react";
import { useInView } from "react-intersection-observer";


function NosotrosComponent() {
  

  const {ref:myRef, inView:myWrapIsVisible} = useInView({
    "threshold": .1,
    "initialInView":true
  });
  const {ref:imagen1, inView:ImageIsVisible} = useInView({
    // triggerOnce:true
      "threshold": .75,
      "initialInView":true
  });

  const {ref:text, inView:textIsVisible} = useInView({
      "threshold":.75,
      "initialInView":true
  })

  const {ref:logo1, inView:logo1IsVisible} =useInView({
    "threshold":1,
      "initialInView":true
  })



  return (<>

    <div ref={myRef} className={`wrapContent ${myWrapIsVisible ? "WrapAnimated":""}`} id="nosotros">
      
      <div class="nosotrosFlexWrap" >
        <div class="WrapTextNosotros">
          <div class="titleNosotros">
            <TitleDisplayerComponent text="Quiénes Somos"/>
          </div>
          <h4 ref={text} className={`TxtContentNosotros ${textIsVisible ? "txtAnimated" : ""}`}>
            Grupo Serdán inició su historia en Los Mochis, Sinaloa en 1999, como
            una tienda de productos para cocinas. Con el pasar de los años,
            nuevas empresas se fueron sumando al grupo, gracias a la preferencia
            de nuestros clientes y a nuestro deseo de proveerles soluciones
            integrales.
            <br/>
            <br/>
            Nuestra amplia gama de productos satisfacen necesidades de exhibición,
            conservación, refrigeración y preparación de alimentos; así
            como la refrigeración de ambientes con equipos de ventilación
            y enfriamiento de espacios abiertos y cerrados, energía solar,
            fabricación de artículos de acero inoxidable y más.</h4>
          <div  class="QSImagenWrap">
            <img src="./Images/comercializadoraCasar.jpg" ref={logo1} className={`QSImagenComercializadora ${logo1IsVisible ? "QSimagen1Animacion" : ""}` }></img>
            <img src="./Images/logo-solarserdan.jpg" ref={logo1} className={`QSImagen ${logo1IsVisible ? "QSimagen2Animacion" : ""}`}></img>
            <img src="./Images/SERDAN NEW (1).png" ref={logo1} className={`QSImagenSerdan ${logo1IsVisible ? "QSimagen3Animacion" : ""}`}></img>
            <img src="./Images/Logo Acero Serdán 3 PNG-02.png" ref={logo1} className={`QSImagenAS  ${logo1IsVisible ? "QSimagen3Animacion" : "" }`}></img>
          </div>
        </div>
        <div className="imageWrapNosotros">
          <div className="nosotrosImageEmpresa">
           <img ref={imagen1}  src="./Images/Encabezado Quiénes Somos-07-01.png" className={`imgSizeNosotros ${ImageIsVisible ? "imgSizeNosotrosAnimated" : ""}`}  alt="" />
          </div>
        </div>
      </div>
    </div>  
  </>
   
  );


  
}

export default NosotrosComponent;
